import Vue from "vue";
import Antd from "ant-design-vue";
import rowSpin from "./rowSpin.vue"; //引入组件
import { Icon } from "ant-design-vue";
const MyIcon = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_1279243_6ufkbojrnij.js" // 在 iconfont.cn 上生成
});
Vue.component("MyIcon", MyIcon);

Vue.use(Antd);
let rowSpinConstructor = Vue.extend(rowSpin); // 返回一个“扩展实例构造器”

let myrowSpin = (obj = {}) => {
  let rowSpinDom = new rowSpinConstructor({
    el: document.createElement("div") //将rowSpin组件挂载到新创建的div上
  });
  rowSpinDom.isShow = true; // 是否显示
  rowSpinDom.msg = obj.msg;
  rowSpinDom.onOk = obj.onOk || function() {};
  rowSpinDom.pickRoomPlanId = obj.pickRoomPlanId;
  document.body.appendChild(rowSpinDom.$el); //把rowSpin组件的dom添加到body里
  rowSpinDom.seqNumber = obj.seqNumber || ""; //显示内容
};
export default myrowSpin;
